import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ConfiguracionParametrosService {

  constructor(private _http: HttpClient) {

  }

  saveConfigUsuario(data: any) {
    const url = environment.URL_BASE + 'parametroAuthorization/saveParametrosUsuario';
    return this._http.post(url, data);
  }

  saveConfigEmpresa(data:any) {
    const url = environment.URL_BASE + 'parametroAuthorization/saveParametrosEmpresa';
    return this._http.post(url, data);
  }

  getInfoEmpresa(id: any) {
    const url = environment.URL_BASE + 'empresaAuthorization/getConfiguracionEmpresa?id=' + id;
    return this._http.get(url);
  }
  getParameter(id: any) {
    const url = environment.URL_BASE + 'parametroAuthorization/get?id=' + id;
    return this._http.get(url);
  }
 

}
